import { getAPI, postAPI } from "../../api/api"
import { REACT_APP_TIMESHEETREPORTS } from "../../utils/common"


export async function getTimeSheetReports(body: any) {
    const Details = postAPI( REACT_APP_TIMESHEETREPORTS + '/timesheet-reports', body)
    return Details
}

export async function getInvoiceReports(body: any) {
    const Details = postAPI( REACT_APP_TIMESHEETREPORTS + '/invoice-reports', body)
    return Details
}

export async function getTimesheetNumbersCompanywise() {
    const Details = getAPI( REACT_APP_TIMESHEETREPORTS + '/customer-timesheet-status')
    return Details
}

export async function getClientwiseSalaryReport(body: any) {
    const Details = postAPI( REACT_APP_TIMESHEETREPORTS + '/salary-bill-report', body)
    return Details
}

export async function getContractReport(body: any) {
    const Details = postAPI( REACT_APP_TIMESHEETREPORTS + '/contract-report-monthly', body)
    return Details
}